import Vue from 'vue'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'

// Retorna os cadastros individuais
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_cns - CNS do profissional
 */
export async function getCadastrosIndividuais(cod_ibge, nu_cns) {
  try {
    const payload = {
      co_ibge: cod_ibge,
      cpf: nu_cns,
    }
    const { data } = await Vue.prototype.$api.post(
      '/app/mudanca-territorio/profissional',
      payload
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna os cadastros individuais por microárea
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da equipe
 * @param {int} micro_area - Micro área do profissional
 */
export async function getCadastrosIndividuaisPorMicroArea(
  cod_ibge,
  nu_ine,
  micro_area
) {
  try {
    const { data } = await Vue.prototype.$api.get(
      `/app/mudanca-territorio/microarea/${cod_ibge}/${nu_ine}/${micro_area}`
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna os cadastros individuais todos de uma equipe
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 */
export async function getCadastrosIndividuaisTodosPorEquipe(cod_ibge, nu_ine) {
  try {
    const { data } = await Vue.prototype.$api.get(
      `/app/mudanca-territorio/equipe/${cod_ibge}/${nu_ine}`
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

export function printTableRow(item) {
  if (item.vermelho == '1') {
    return 'red'
  }
  return 'green'
}
export function exibirVermelhos(cadastros) {
  let filtro = cadastros.filter((item) => {
    if (item.vermelho == '1') {
      return true
    } else {
      return false
    }
  })
  return filtro
}

export function exibirVerdes(cadastros) {
  let filtro = cadastros.filter((item) => {
    if (item.vermelho == '0') {
      return true
    } else {
      return false
    }
  })

  return filtro
}

export function generatePdf(
  cadastros,
  selectEquipe,
  selectProfissional,
  nomeProfissional,
  data_secretaria_de_saude
) {
  const titlePdf = 'Mudança de Território'
  const titlePdfSave = utils.methods.titlePdf(titlePdf, selectEquipe.no_equipe)
  const descriptionPdf = 'Cidadãos com mudança de território ativa na FCI'
  const headersPdf = [
    'NOME',
    'NASCIMENTO',
    'MÃE',
    'MA',
    'ÓBITO',
    'PROCEDIMENTO',
    'OUT. ATENDIMENTO',
    'ODONTO',
    'VISITA',
    'DATA FICHA',
    'DOCUMENTO',
  ]

  const dataPdf = cadastros.map((c) => {
    const documentos = []
    if (c.nu_cpf) documentos.push(`CPF ${c.nu_cpf}`)
    if (c.nu_cns) documentos.push(`CNS ${c.nu_cns}`)

    return {
      no_cidadao: c.no_cidadao,
      dt_nascimento: utils.methods.formatDate(c.dt_nascimento),
      no_mae: c.no_mae,
      micro_area: c.micro_area,
      dt_obito: utils.methods.formatDate(c.dt_obito),
      dt_procedimento: c.dt_procedimento,
      dt_atendimento_med_enf: c.dt_atendimento_med_enf,
      dt_atendimento_odo: c.dt_atendimento_odo,
      dt_visita: c.dt_visita,
      dt_ultima_ficha: utils.methods.formatDate(c.dt_ultima_ficha),
      documento: documentos.join('\n'),
      vermelho: c.vermelho,
    }
  })

  const table = utils.methods.createTablePdf(dataPdf)
  const doc = new jsPDF(utils.methods.encryptionPdf())

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64Brasao) => {
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64Brasao,
        titlePdf,
        descriptionPdf
      )

      const equipeInfo = [
        { label: 'Equipe', value: selectEquipe.no_equipe },
        { label: 'CNES', value: selectEquipe.nu_cnes },
        { label: 'INE', value: selectEquipe.nu_ine },
        { label: 'Profissional ACS', value: nomeProfissional },
      ]

      verticalPosition = utils.methods.bodyPdf(
        doc,
        equipeInfo,
        verticalPosition
      )

      doc.autoTable({
        head: [headersPdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: ({ row, section }) => {
          if (section === 'head') {
            doc.setTextColor(0, 0, 0)
          } else {
            const vermelho = row.raw[11]
            if (vermelho == '1') {
              doc.setTextColor(194, 10, 16)
            } else {
              doc.setTextColor(2, 99, 57)
            }
          }
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)
      doc.save(`${titlePdfSave}.pdf`)

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

export async function carregarSerieHistoricaPorEquipe(cod_ibge, nu_ine, xaxis) {
  try {
    let response = await Vue.prototype.$api.get(
      '/app/serie-historica/equipe/' + cod_ibge + '/' + nu_ine + '/4'
    )
    let array_chart_equipe = []
    for (let i = 0; i < xaxis.length; i++) {
      var eixo_x_atual = xaxis[i]
      for (const item of response.data) {
        var resultado = 0
        if (item.mes_ano == eixo_x_atual) {
          resultado = item.resultado
          break
        } else {
          resultado = null
        }
      }
      array_chart_equipe.push(resultado)
    }
    return array_chart_equipe
  } catch (err) {
    console.log(err)
  }
}
export async function carregarSerieHistoricaPorAcs(
  cod_ibge,
  profissional,
  xaxis
) {
  try {
    let response = await Vue.prototype.$api.get(
      '/app/serie-historica/acs/' + cod_ibge + '/' + profissional + '/4'
    )
    let array_chart_acs = []
    if (response.data.length !== 0) {
      for (let i = 0; i < xaxis.length; i++) {
        var eixo_x_atual = xaxis[i]
        for (const item of response.data) {
          var resultado = 0
          if (item.mes_ano == eixo_x_atual) {
            resultado = item.resultado
            break
          } else {
            resultado = null
          }
        }
        array_chart_acs.push(resultado)
      }
      return array_chart_acs
    } else {
      return null
    }
  } catch (err) {
    console.log(err)
  }
}

export function handleSituacao(data, situacao) {
  let filtrado = data.filter((item) => {
    if (situacao === 'Todos') {
      return item
    }
    if (situacao === '24 anos') {
      return Number(item.idade) == 24
    } else if (situacao === 'Entre 25-35 anos') {
      return (
        Number(item.idade) >= 25 &&
        Number(item.idade) <= 35 &&
        item.idade !== null
      )
    } else if (situacao === 'Entre 36-45 anos') {
      return (
        Number(item.idade) >= 36 &&
        Number(item.idade) <= 45 &&
        item.idade !== null
      )
    } else if (situacao === 'Entre 46-55 anos') {
      return (
        Number(item.idade) >= 46 &&
        Number(item.idade) <= 55 &&
        item.idade !== null
      )
    } else if (situacao === 'Entre 56-63 anos') {
      return (
        Number(item.idade) >= 56 &&
        Number(item.idade) <= 63 &&
        item.idade !== null
      )
    } else if (situacao === 'Com 64 anos') {
      return Number(item.idade) == 64 && item.idade !== null
    } else if (situacao === 'No denominador? Sim') {
      return item.denominador == '1'
    } else if (situacao === 'Atendimento recente') {
      return item.dias_ult_atend !== null && Number(item.dias_ult_atend) < 91
    } else {
      return item
    }
  })
  return filtrado
}
